import React from 'react'
import img from './Images/Footer/micoco.png'
import img1 from './Images/Footer/gmail.png'
import img2 from './Images/Footer/linkdin.png'
import img3 from './Images/Footer/discord.png'

const Footer = () => {
  return (
    <>
      <footer>
        <img src={img} alt="" className='img'/>
        <div className="left">
          <div className='social'>
            <img src={img1} alt="" /> 
            <span>Nwankwomicheal01@gmail.com</span> 
          </div>
          <div className='social'>
            <img src={img2} alt="" />
            <span>Micheal . A .Nwankwo</span>  
          </div>
          <div className='social'>
            <img src={img3} alt="" />
            <span>moore2466</span>
          </div>
        </div>
        <h1 className="title">Thank you</h1>
      </footer>
    </>
  )
}

export default Footer